import { RemoveCircleOutline } from "@mui/icons-material";
import { styled } from "@mui/material";

const StyledDivContainer = styled("div")({
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginTop: "40vh",
});

const StyledDivIconContainer = styled("div")({
    textAlign: "center",
});

const StyledDivAlertText = styled("div")({
    fontSize: "22px",
});

const RestrictedAccess = (props) => {
    const { message } = props;

    return (
        <StyledDivContainer>
            <StyledDivIconContainer>
                <RemoveCircleOutline style={{ fill: "rgb(224, 68, 3)" }} />
            </StyledDivIconContainer>
            {message ? (
                <StyledDivAlertText>{message}</StyledDivAlertText>
            ) : (
                <StyledDivAlertText>You do not have permission to view this page</StyledDivAlertText>
            )}
        </StyledDivContainer>
    );
};

export default RestrictedAccess;
